<app-loader></app-loader>
<div class="delete-outer">
    <div class="modal-inner-wraper">
        <img src="../../../../assets/images/reattempt-icon.svg" alt="" />
        <h3 class="reset-heding">{{headerText}}</h3>
        <p [innerHTML] = "bodyText"></p>
        <h5 *ngIf="isFunctionAttempted === 2">This process may take around 1 to 2 hours to complete.</h5>
        <div class="yes-no-btn">
            <p-button label="Yes" class="btn-continue" (onClick)="yesButtonFun()"></p-button>
            <p-button label="No" class="btn-continues" (onClick)="noButtonFun()"></p-button>
        </div>
    </div>
</div>